import { updateItems } from '@/mocks/homeData';

const tagStyles: Record<string, string> = {
  '上新': 'bg-primary-100 text-primary-700',
  '更新': 'bg-accent-100 text-accent-700',
  '热播': 'bg-red-100 text-red-700',
  '预告': 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">最新更新</h2>
          <p className="mt-2 text-sm text-foreground-500">实时快讯，追剧不迷路</p>
        </div>

        <div className="relative">
          <div className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-px bg-background-200"></div>
          <div className="flex flex-col gap-3 md:gap-4">
            {updateItems.map((item) => (
              <div key={item.id} className="flex items-start gap-4 md:gap-5 cursor-pointer group">
                <div className="relative flex-shrink-0 mt-0.5">
                  <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-100 border-2 border-background-200 flex items-center justify-center z-10 relative">
                    <span className="text-[10px] md:text-xs font-semibold text-foreground-600 whitespace-nowrap">{item.date}</span>
                  </div>
                </div>
                <div className="flex-1 min-w-0 pb-3 md:pb-4 border-b border-background-100">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${tagStyles[item.tag] || 'bg-background-100 text-foreground-600'}`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 group-hover:text-primary-500 transition-colors leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}